import { render, staticRenderFns } from "./LeftFilter1new.vue?vue&type=template&id=4d677dda&"
import script from "./LeftFilter1new.vue?vue&type=script&lang=js&"
export * from "./LeftFilter1new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports